import ContactManagementReducer from 'store/contact/reducers';

export default ContactManagementReducer;
